:global(.ms-Overlay) {
    background: transparent !important;
}

.modalContainer {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
    height: 100vh;
    position: fixed;
    top: 0;
    left: 0;
    background: linear-gradient(135deg, #7a4ff6 0%, #00c2ff 100%);
    background-attachment: fixed;
    background-size: cover;
}

.modalBox {
    padding: 50px 60px;
    max-width: 480px;
    width: 90%;
    background: rgba(255, 255, 255, 0.8);
    border-radius: 20px;
    box-shadow: 0 8px 25px rgba(0, 0, 0, 0.25);
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    min-height: 240px;
    border: 1px solid rgba(255, 255, 255, 0.3);
    backdrop-filter: blur(12px);
    transition: all 0.3s ease;
}

/* .modalBox:hover {
    transform: translateY(-2px);
    box-shadow: 0 12px 30px rgba(0, 0, 0, 0.25);
} */

.title {
    margin-bottom: 30px;
    text-align: center;
    font-size: 26px;
    font-weight: 600;
    background: linear-gradient(90deg, #7a4ff6, #00c2ff);
    -webkit-background-clip: text;
    background-clip: text;
    -webkit-text-fill-color: transparent;
}

.filterWrapper {
    width: 100%;
    display: flex;
    justify-content: center;
}

/* Dropdown appearance */
:global(.ms-Dropdown) {
    min-width: 200px;
}

:global(.ms-Dropdown-title) {
    border-radius: 8px !important;
    border: 1px solid #c5c5c5 !important;
    background-color: #ffffff !important;
    transition: all 0.2s ease;
}

:global(.ms-Dropdown-title:hover) {
    border-color: #7a4ff6 !important;
    box-shadow: 0 0 0 2px rgba(122, 79, 246, 0.25);
}

:global(.ms-Dropdown-caretDown) {
    color: #7a4ff6 !important;
}
